// src/common/firebase.js
// ─────────────────── Firebase 초기화 및 SDK 설정 ───────────────────
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';                      // ← Auth 추가
import {
  getFirestore,
  collection,
  addDoc,
  serverTimestamp,
} from 'firebase/firestore/lite';

// TravelMate Firebase 프로젝트 설정
const firebaseConfig = {
  apiKey: "AIzaSyDPmUiXul_n1tDn9QGVvCoPBPuF2xzoTZE",
  authDomain: "travelmate-ac229.firebaseapp.com",
  projectId: "travelmate-ac229",
  storageBucket: "travelmate-ac229.firebasestorage.app",
  messagingSenderId: "96570997839",
  appId: "1:96570997839:web:34b3c8b134a9c62e47fe3a"
};

// Firebase 앱 초기화
const app = initializeApp(firebaseConfig);

// Firestore 인스턴스 내보내기
export const db   = getFirestore(app);
// Auth 인스턴스 내보내기
export const auth = getAuth(app);

/**
 * 연락처 폼 데이터를 Firestore 'contacts' 컬렉션에 저장
 * @param {{ name, email, company, phone, subject, message }} data
 */
export async function saveContact(data) {
  await addDoc(collection(db, 'contacts'), {
    ...data,
    checked: false,            // 새 문의는 미확인 상태로 저장
    createdAt: serverTimestamp(), // 생성 시점 타임스탬프
  });
}
